import { useGraphqlQuery } from "@mzara/component";
import { TUser } from "@mzara/graphql";
import _ from "lodash";
import { AppointmentEventUsersQuery } from "../query/AppointmentBoardUsersQuery";

export const useAppointmentEventUsersQuery = (suspense?: boolean) => {

    return useGraphqlQuery<AppointmentEventUsersQuery, Array<TUser>>(new AppointmentEventUsersQuery(), { suspense });
};